import React, { useContext } from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import { Text } from "@dhxete/text";
import Agent from "./Agent/Agent";
import Case from "./Case/Case";
import { useAppContext } from "../Context";
const QuestionStyle = styled.div`
  position: absolute;
  display: flex;
  flex-flow: column;
  justify-content: center;
  height: 170px;
  width: calc(100% + 57px);
  align-items: center;
  background: #f7f7f7;
  margin: 30px 0px 0px -30px;
  padding-bottom: 20px;
`;

const Question = ({
  className,
  questionId,
  caseButtonId,
  agentButtonId
}) => {
  const {
    state: {
      langStrings
    },
    handleExpansion,
    hasExtension
  } = useAppContext();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: className,
    onClick: handleExpansion,
    id: questionId
  }, /*#__PURE__*/React.createElement(Text, {
    fontWeight: 600,
    color: "#0695d7"
  }, `${hasExtension ? "-" : "+"} ${langStrings.buttons.haveAQuestion}`)), /*#__PURE__*/React.createElement(QuestionStyle, null, /*#__PURE__*/React.createElement(Agent, {
    id: agentButtonId
  }), /*#__PURE__*/React.createElement(Case, {
    id: caseButtonId
  })));
};

Question.propTypes = {
  className: PropTypes.string,
  questionId: PropTypes.string,
  caseButtonId: PropTypes.string,
  agentButtonId: PropTypes.string
}; // Matches model width.

export default styled(Question)`
  display: flex;
  justify-content: center;
  align-items: center;
  background: #f7f7f7;
  height: 50px;
  max-width: 550px;
  margin: 30px -30px -30px -30px;
  cursor: pointer;
`;